const ContactMe = () => {
    return (
        <section id="Contact" className="contact--section">
          <div>
              <p className="sub--title">Get In Touch</p>
              <h2>Contact Me</h2>
              <p text-lg>Feel free to inquire about anything I can help with. I look forward to connecting with you!</p>
          </div>
  
          <form className="contact--form--container" method="POST" action="https://api.web3forms.com/submit">
              <div className="container">
                 <input type="hidden" name="access_key" value="ff424f53-ba05-4a1c-abad-4dd8cd53ee58"></input> 

                  <label htmlFor="first-name" className="contact--label">
                      <span className="text-md">First Name</span>
                      <input type="text" className="contact--input text-md" name="first-name" id="first-name" required></input>
                  </label>
  
                  <label htmlFor="last-name" className="contact--label">
                      <span className="text-md">Last Name</span>
                      <input type="text" className="contact--input text-md" name="last-name" id="last-name" required></input>
                  </label>
  
                  <label htmlFor="email" className="contact--label">
                      <span className="text-md">Email</span>
                      <input type="email" className="contact--input text-md" name="email" id="email" required></input>
                  </label>
  
                  <label htmlFor="phone-number" className="contact--label">
                      <span className="text-md">Phone Number</span>
                      <input type="number" className="contact--input text-md" name="phone-number" id="phone-number" required></input>
                  </label>
              </div>
  
              <label htmlFor="message" className="contact--label">
                      <span className="text-md">Message</span>
                      <textarea className="contact--input text-md" id="message" rows="8" placeholder="input your messsage" name='message'/>
              </label>
  
               <label htmlFor="checkbox" className="checkbox--label">
                  <input type="checkbox" id="checkbox" required name="checkbox"></input>
                  <span className="text-sm">I accept the terms</span>
              </label>
  
                  <div>
                    <button className="btn btn-primary contact--form--btn">Reach Out</button>  
                  </div>   
          </form>
        </section>
    )
  }
  
  export default ContactMe



 